// extracted by mini-css-extract-plugin
export default {"SiteCollapseCustomCollapsePanel":"FilterSideBarElementLight__SiteCollapseCustomCollapsePanel___RuPde","tooltip":"FilterSideBarElementLight__tooltip___lHUED"};